import { useChatVisibility as useChatVisibilityCore } from "@core/features/chat";
import type { Circle } from "@core/types/core.types";
import { useTalkJSData } from "./useChat";

export type UseChatVisibilityArgs = {
  /** User's circles for access control */
  userCircles: Circle[] | null | undefined;
  /** Optional local override to disable chat (e.g., from feature flag) */
  isChatDisabled?: boolean;
};

/**
 * Platform-specific wrapper for useChatVisibility.
 * Automatically wires up TalkJS data from React Query.
 *
 * @example
 * ```typescript
 * const userCircles = usePlatformStore((s) => s.userCircles);
 * const { shouldShowChat, isLoading } = useChatVisibility({
 *   userCircles,
 *   isChatDisabled: false,
 * });
 * ```
 */
export function useChatVisibility({
  userCircles,
  isChatDisabled,
}: UseChatVisibilityArgs) {
  const talkjsData = useTalkJSData();

  return useChatVisibilityCore({
    talkjsData,
    userCircles,
    isChatDisabled,
  });
}

